<template>
  <div class="floating-chat" :style="transparentColor">
    <div :style="styleSidebarTitle" class="sidebar-header">
      <h1 class="sidebar-title">Chat</h1>
      <img @click="toggleChat" :src="cancelIcon" class="cancelIcon" />
    </div>
    <FloatingChatMessages v-show="sessionLoaded" :user="user" :partnerMetadata="partnerMetadata" />
    <FloatingChatSubmit v-show="sessionLoaded" />
    <div class="floating-chat--error" v-if="chatError">{{ chatError }}</div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import cancelIcon from "../../../assets/images/cancel.png";
import FloatingChatMessages from "./FloatingChatMessages";
import FloatingChatSubmit from "./FloatingChatSubmit";
import { transparentColor } from "../Session/SessionHelpers/colors";

export default {
  name: "FloatingChat",
  components: {
    FloatingChatMessages,
    FloatingChatSubmit,
  },
  props: ["sessionLoaded", "user"],
  data() {
    return {
      cancelIcon: cancelIcon,
      themeCoreColor: "#323b50",
    };
  },
  computed: {
    ...mapState({
      partnerMetadata: (state) => state.session.partnerMetadata,
      chatError: (state) => state.session.chatError,
    }),
    styleSidebarTitle() {
      return `color: ${this.themeCoreColor};`;
    },
    transparentColor() {
      return transparentColor();
    },
  },
  methods: {
    toggleChat() {
      this.$store.dispatch("toolbar/toggleChat");
    },
  },
};
</script>
<style scoped>
.floating-chat {
  width: 330px;
  height: calc(100% - 210px); /* Account for bottom bar + top bar */
  border-radius: 10px;
  /* box-shadow: 0 1px 4px 0 rgb(206 206 206 / 42%) !important; */
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: absolute;
  right: 45px;
  top: 120px;
  background-color: rgba(255, 255, 255, 0.65);
  -webkit-backdrop-filter: blur(8px);
  backdrop-filter: blur(5px);
  box-shadow: 0 1px 4px 0 hsl(0deg 0% 69% / 40%);
  z-index: 3;
}
.floating-chat--error {
  color: rgb(160, 0, 0);
  margin-top: -12px;
  margin-bottom: 5px;
  font-size: 14px;
  text-align: center;
}

.sidebar-header {
  border-radius: 15px;
  justify-content: space-between;
  text-transform: capitalize;
  width: calc(100% - 36px);
  margin-left: 1px;
  align-items: center;
  padding-left: 20px !important;
  padding-right: 20px !important;
  padding-bottom: 16px !important;
  padding-top: 16px !important;
  display: flex;
}

.sidebar-title {
  align-items: center;
  display: flex;
  font-size: 20px;
  font-weight: 600;
  color: #222;
}

.cancelIcon {
  width: 14px;
  height: 14px;
  padding: 8px;
  border-radius: 20px;
  cursor: pointer;
  margin-bottom: auto;
}

.cancelIcon:hover {
  background-color: #ffffffa6;
  box-shadow: 0 1px 4px 0 #c1c1c166;
}
</style>
